<template>
  <div id="hres89u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres89uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres89u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>

    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :arrCodemprc="dropdowns.codemprc"
            :postHres89uSendApprove="postHres89uSendApprove" 
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :detailSubmit="detailSubmit"
            :receivedHres89uDetailSubmit="receivedHres89uDetailSubmit" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres89u/mutation-types'
import detail from 'components/hres89u/detail'
import popupApprove from 'components/hres89u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres89u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres89uColumnsLabels()
    this.receivedHres89uIndex()
    // this.receivedHres89uApprove()
    this.receivedHres89uDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES89U_INDEX_DISP,
      detailDisp: types.GET_HRES89U_DETAIL_DISP,
      columns: types.GET_HRES89U_COLUMNS,
      labels: types.GET_HRES89U_LABELS,
      index: types.GET_HRES89U_INDEX,
      indexSelected: types.GET_HRES89U_INDEX_SELECTED,
      detail: types.GET_HRES89U_DETAIL,
      dropdowns: types.GET_HRES89U_DROPDOWNS,
      detailSubmit: types.GET_HRES89U_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres89uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres89uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES89U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES89U_PAGE,
      receivedHres89uColumnsLabels: types.RECEIVED_HRES89U_COLUMNS_LABELS,
      receivedHres89uIndex: types.RECEIVED_HRES89U_INDEX,
      receivedHres89uDetail: types.RECEIVED_HRES89U_DETAIL,
      receivedHres89uDetailSubmit: types.RECEIVED_HRES89U_DETAIL_SUBMIT,
      postHres89uSendApprove: types.POST_HRES89U_SEND_APPROVE,
      receivedHres89uDropdowns: types.RECEIVED_HRES89U_DROPDOWNS
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?09601739